import React from 'react';
// import logo1 from '../../assets/images/FAO_logo.png';
// import logo2 from '../../assets/images/EBRD_logo.png';
//import back from '../../assets/images/05_oblacinka.jpg';

class Footer extends React.Component{
  render(){
    return (
      <div className="footer-wrapper" style={{backgroundImage: `url(${this.props.src})`}}>
        <div className='footer-content-wrap'>
            <div className='footer-heading'>
                <p className='black-roboto white'>{this.props.supported}</p>
            </div>
            <div className='footer-description'>
              <p>{this.props.footertext}</p>
                {/* <div className='logo-wrap'>
                    <img src={logo1} alt='logo1' />
                </div>
                <div className='logo-wrap'>
                    <img src={logo2} alt='logo2' />
                </div> */}
            </div>
        </div>
      </div>
    )
  }
}

export default Footer;
